var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18V11.4L3.85 16.075L2.425 14.65L7.1 10H0.5V8H7.1L2.425 3.35L3.85 1.925L8.5 6.6V0H10.5V6.6L15.15 1.925L16.575 3.35L11.9 8H18.5V10H11.9L16.575 14.65L15.15 16.075L10.5 11.4V18H8.5Z",
    fill: "#007DFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.db826be103747ff4702c9b728453526c.svg";
export { ForwardRef as ReactComponent };